import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";

import Order from "~/pages/Order";
import { SeccondModalButtons, BackIcon } from "./styles";
import HeaderMobile from '~/components/layout/HeaderOld';
import back from '~/assets/images/arrow.svg';

export default function OrderModal(props) {
  const dispatch = useDispatch();
  const orderReducer = useSelector((state) => state.orderReducer);
  const activeModal = useSelector((state) => state.orderReducer.activeModal);
  const errorOrder = useSelector((state) => state.orderReducer.errorOrder);

  const [showSecondModal, setShowSecondModal] = useState(false);
  const [showModal, setShowModal] = useState(true);

  useEffect(() => {
    let activeOrder = activeModal ? activeModal.order : false
    if((activeOrder && window.screen.width > 768) || (errorOrder && window.screen.width > 768)) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [activeModal]);

  const HeaderComponent = () => (
    <>
      <HeaderMobile />
      <BackIcon
        onClick={() => {
          props.activeModalOrder();
          dispatch({ type: 'ORDER_DONE' });
        }}
      >
        <img src={back} alt="Ícone para voltar" />
      </BackIcon>
    </>
  );

  return (
    <>
      <Modal
        show={showSecondModal}
        onHide={() => {
          setShowSecondModal(true);
        }}
        className="order-seccond"
      >
        <Modal.Body>
          <div>
            <div>
              <span>Tem certeza que deseja fechar o pedido?</span>
            </div>
            <SeccondModalButtons>
              <Button
                style={{ marginRight: ".7rem", padding: "0 1rem" }}
                variant="secondary"
                onClick={() => {
                  setShowSecondModal(false);
                  dispatch({ type: "ORDER_DONE" });
                  dispatch({ type: "SET_ERROR_ORDER", errorOrder: false });
                  dispatch({ 
                    type: "ACTIVE_ORDER_MODAL", 
                    activeModal: { order: false, modal: !activeModal.modal }
                  });
                  dispatch({ type: "SET_ORDER_TAKE", orderTake: false });
                  dispatch({ type: "ADD_DATE", date: "" });
                  setShowModal(false);
                  props.activeModalOrder();
                }}
              >
                Sim
              </Button>
              <Button
                variant="primary"
                onClick={() => setShowSecondModal(false)}
                style={{ marginRight: ".7rem", padding: "0 1rem" }}
              >
                Não
              </Button>
            </SeccondModalButtons>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModal}
        onHide={() => {
          setShowSecondModal(true);
        }}
        centered
        className="employee-modal"
      >
        <Modal.Body style={{ 
          padding: '0 35px', 
          display: orderReducer.modalEditOpen ? "none" : "block" 
        }}>
          <HeaderComponent />
          <div style={{ overflowY: "scroll" }}>
            <Order 
              desktop={true} 
              activeModalOrder={props.activeModalOrder} 
              isModalActive={activeModal.order}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
